/**
 * @fileoverview Layout raiz da aplicação com Next.js App Router
 * @module RootLayout
 * @version 1.0.0
 *
 * Fornece a estrutura HTML base e contextos globais para toda a aplicação.
 * Inclui providers, fonte otimizada e verificação global de sessão NextAuth expirada.
 */

"use client";
import "./globals.css";
import { Providers } from "visuais";
import { Inter } from "next/font/google";
import { ReactNode } from "react";
import { AuthGuard } from "visuais";

const inter = Inter({ subsets: ["latin"] });

/**
 * Layout raiz da aplicação
 *
 * @param props - Propriedades do layout
 * @param props.children - Conteúdo das páginas
 * @returns Estrutura HTML raiz
 */
export default function RootLayout({ children }: { children: ReactNode }) {
  return (
    <html lang="pt-BR" suppressHydrationWarning suppressContentEditableWarning>
      <head>
        <title>RodoAPP</title>
      </head>
      <body className={inter.className}>
        <Providers>
          <AuthGuard>
            {children}
          </AuthGuard>
        </Providers>
      </body>
    </html>
  );
}
